<div class="min-h-screen flex items-center justify-center p-4" style="background-color: #1a1a2e">
  <!-- Imagen de fondo -->
  <div
    class="absolute inset-0 bg-cover bg-center opacity-30"
    style="background-image: url('/images/background-login.png')"
  ></div>

  <!-- Overlay -->
  <div
    class="absolute inset-0"
    style="
      background: linear-gradient(135deg, rgba(252, 65, 90, 0.4) 0%, rgba(85, 220, 206, 0.2) 100%);
    "
  ></div>

  <!-- Card principal -->
  <div class="relative w-full max-w-md">
    <div
      class="rounded-2xl bg-white dark:bg-gray-900 shadow-2xl border border-gray-200 dark:border-gray-800 overflow-hidden"
    >
      <div class="p-8">
        <!-- Icon -->
        <div class="flex justify-center mb-6">
          <div
            class="h-16 w-16 rounded-full flex items-center justify-center"
            style="background-color: rgba(252, 65, 90, 0.1)"
          >
            <fa-icon [icon]="faLock" class="text-2xl" style="color: #fc415a"></fa-icon>
          </div>
        </div>

        <!-- Title -->
        <h1 class="text-2xl font-bold text-gray-900 dark:text-white text-center mb-2">
          Bienvenido a SDi Massmarket
        </h1>
        <p class="text-sm text-gray-600 dark:text-gray-300 text-center mb-8">
          Introduce tu nueva contraseña
        </p>

        <!-- Email info -->
        @if (email) {
          <div
            class="mb-6 p-3 rounded-lg border"
            style="background-color: rgba(252, 65, 90, 0.1); border-color: rgba(252, 65, 90, 0.3)"
          >
            <p class="text-sm text-center" style="color: #fc415a">
              Nuevo usuario: <strong>{{ email }}</strong>
            </p>
          </div>
        }

        <!-- Form -->
        <form [formGroup]="form" (ngSubmit)="submit()" class="space-y-4">
          <div>
            <label
              for="password"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              Nueva contraseña
            </label>
            <input
              id="password"
              type="password"
              formControlName="password"
              class="app-input w-full"
              placeholder="Mínimo 8 caracteres"
            />
            @if (form.controls.password.touched && form.controls.password.invalid) {
              <p class="text-sm text-red-600 dark:text-red-400 mt-2">
                La contraseña debe tener al menos 8 caracteres.
              </p>
            }
          </div>

          <div>
            <label
              for="password_confirmation"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              Confirmar contraseña
            </label>
            <input
              id="password_confirmation"
              type="password"
              formControlName="password_confirmation"
              class="app-input w-full"
              placeholder="Repite tu contraseña"
            />
            @if (
              form.controls.password_confirmation.touched &&
              form.controls.password_confirmation.invalid
            ) {
              <p class="text-sm text-red-600 dark:text-red-400 mt-2">
                Por favor, confirma tu contraseña.
              </p>
            }
          </div>

          @if (errorMessage) {
            <div
              class="rounded-lg bg-red-50 dark:bg-red-500/10 border border-red-200 dark:border-red-500/50 p-3 text-sm text-red-700 dark:text-red-400"
            >
              {{ errorMessage }}
            </div>
          }

          <button
            type="submit"
            [disabled]="isLoading"
            class="app-btn app-btn--primary app-btn--center w-full"
          >
            @if (!isLoading) {
              <span>Crear contraseña</span>
            } @else {
              <span>Iniciado sesión...</span>
            }
          </button>

          <div class="text-center">
            <span class="text-sm text-gray-600 dark:text-gray-300">
              Ya tengo una contraseña.
              <a
                routerLink="/login"
                class="text-sm text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white underline transition"
              >
                Iniciar sesión.
              </a>
            </span>
          </div>
        </form>
      </div>
    </div>

    <!-- Footer -->
    <div class="text-center mt-6 text-xs text-white/70">
      <p>© 2026 SDi Partner Panel. Todos los derechos reservados.</p>
    </div>
  </div>
</div>
